import styled from "styled-components";
import type { WidthProps } from "styled-system";
import { width } from "styled-system";
import { theme } from "../theme/toyotaTheme";
import { bodyStyle } from "../globals/Type";
import { getBreakpoint, getDirection } from "../../../../themes/common";

export const RATING_WIDTH = 120;

export const Number = styled.span<{ isPrimary?: boolean }>`
    display: none;
    margin-${getDirection("left")}: ${theme.space[1]}px;
    color: ${theme.colors.primaryBlack};
    ${bodyStyle};
    @media ${getBreakpoint("up", "md")} {
        display: inline-block;
    }
`;

export const StarRating = styled.div`
    position: relative;
`;

export const Stars = styled.div`
    width: ${RATING_WIDTH}px;
    opacity: 1;
`;

export const StarsScore = styled.div<WidthProps>`
    position: absolute;
    top: 0;
    ${getDirection("left")}: 0;
    max-width: ${RATING_WIDTH}px;
    overflow: hidden;
    ${width};

    div {
        white-space: nowrap;
    }
`;

export const Review = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    color: ${theme.colors.primaryBlack};
`;
